export const USER_DAC7_ACTION_TYPE = {
  SET_ACCOUNT_TYPE: 'user-dac7/set-account-type',
  SET_INFORMATION: 'user-dac7/set-information',
  SET_REQUIRED_ERROR: 'user-dac7/set-required-error',
  SET_CONDITIONALLY_REQUIRED_ERROR: 'user-dac7/set-conditionally-required-error',
  SET_INVALID_VALUE_ERROR: 'user-dac7/set-invalid-value-error',
  CLEAR_ERROR: 'user-dac7/clear-error',
  VALIDATE_FORM: 'user-dac7/validate-form',
  OPEN_CONFIRMATION: 'user-dac7/open-confirmation',
  CANCEL_CONFIRMATION: 'user-dac7/cancel-confirmation',
  SUBMIT_CONFIRMATION: 'user-dac7/submit-confirmation',
  PREFILL_FORM_WITH_SUBMITTED_DATA: 'user-dac7/prefill-form-with-submitted-data',
  SET_FORM_SUBMITTED: 'user-dac7/set-form-submitted',
} as const;
